// Drawer Configuration - Reusable across multiple websites

/**
 * Mini Drawer Configuration:
 * - Always visible on left
 * - Collapsed: Icons only (65px)
 * - Expanded: Icons + text (240px)
 * - Toggle with hamburger menu
 */

export const drawerConfig = {
  enabled: true,         // Sidebar enabled
  showMenuIcon: true,    // Show hamburger menu icon to toggle
  width: 240,            // Width when expanded (with text)
  miniWidth: 65,         // Width when collapsed (icons only)
  anchor: 'left',        // Position: 'left' or 'right'
  variant: 'permanent',  // 'permanent' (always visible)
  defaultOpen: false     // Start collapsed (icons only)
};

export default drawerConfig;
